import { useDeviceType } from '@cian/ui-kit';
export function useSecondaryButtonTheme() {
  var deviceType = useDeviceType();
  var isPhone = deviceType === 'phone';
  return isPhone ? 'fill_secondary' : 'fill_white_primary';
}